(function($, angular, window) {
    'use strict';
    window.THF.Angular.JoinForm.directive('fieldCompileTemplate', ['$compile', '$parse', function($compile, $parse){
        return {
            link: function(scope, element, attr){
                var parsed = $parse(attr.ngBindHtml);
                function getStringValue() { return (parsed(scope) || '').toString(); }
                scope.$watch(getStringValue, function() {
                    $compile(element.contents())(scope.$parent);
                });
            }
        }
    }]);

})(jQuery, angular, window);